import React from "react";
import { signOut, getAuth } from "firebase/auth";
import { app } from "../../firebase";

const RESET_KEYS = [
  "orgId",
  "storeId",
  "storeName",
  "orgName",
  "deviceUid",
  "managerId",
  "managerName",
  "staffName",
  "staffId",
  "managerSession",
  "cashup_manager_session",
  "session_manager",
  "cashup_staff_session",
  "staffSession",
  "session_staff",
  "cashup.session",
  "linkedOrgId",
  "linkedStoreId",
  "linkedStoreName",
  "workspacePinVerified",
  "deviceLinked",
  "deviceLinkToken",
  "deviceSession",
  "installParams",
  "deviceType",
];

async function resetLinkedDeviceState() {
  try {
    RESET_KEYS.forEach((k) => localStorage.removeItem(k));
  } catch {}

  try {
    sessionStorage.clear();
  } catch {}

  try {
    const auth = getAuth(app);
    if (auth.currentUser) {
      await signOut(auth);
    }
  } catch {}

  window.location.replace("/link");
}

export default function SecurityUnlinkPage() {
  const handleUnlink = async () => {
    const ok = window.confirm("Are you sure you want to unlink this device?");
    if (!ok) return;
    await resetLinkedDeviceState();
  };

  return (
    <div
      style={{
        minHeight: "100vh",
        background:
          "radial-gradient(circle at top, rgba(14,165,233,.16), transparent 34%), linear-gradient(180deg, #020617 0%, #0f172a 100%)",
        color: "#e2e8f0",
        padding: 24,
        fontFamily:
          '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif',
      }}
    >
      <div
        style={{
          width: "min(1100px, 100%)",
          margin: "0 auto",
          display: "grid",
          gap: 24,
        }}
      >
        <div
          style={{
            borderRadius: 24,
            background: "rgba(15,23,42,.78)",
            border: "1px solid rgba(255,255,255,.08)",
            padding: 24,
            boxShadow: "0 22px 60px rgba(0,0,0,.35)",
          }}
        >
          <div
            style={{
              display: "inline-flex",
              padding: "8px 12px",
              borderRadius: 999,
              background: "rgba(14,165,233,.18)",
              border: "1px solid rgba(14,165,233,.35)",
              fontSize: 12,
              fontWeight: 900,
              letterSpacing: ".08em",
              textTransform: "uppercase",
            }}
          >
            Neo Security
          </div>

          <h1 style={{ margin: "16px 0 8px", fontSize: 40, lineHeight: 1.1 }}>
            Unlink Device
          </h1>
          <p style={{ margin: 0, fontSize: 16, lineHeight: 1.7, opacity: 0.9 }}>
            Clear this linked device session, then relink the phone or tablet to a
            different organization or mode.
          </p>

          <div style={{ display: "flex", gap: 12, flexWrap: "wrap", marginTop: 20 }}>
            {[
              ["/security", "Home"],
              ["/security/shift", "Shift"],
              ["/security/patrols", "Patrols"],
              ["/security/incidents", "Incidents"],
              ["/security/unlink", "Unlink"],
            ].map(([href, label]) => {
              const active = href === "/security/unlink";
              return (
                <a
                  key={href}
                  href={href}
                  style={{
                    textDecoration: "none",
                    padding: "10px 16px",
                    borderRadius: 14,
                    fontWeight: 900,
                    border: active
                      ? "1px solid rgba(34,211,238,.35)"
                      : "1px solid rgba(255,255,255,.08)",
                    background: active
                      ? "linear-gradient(90deg, rgba(16,185,129,1), rgba(14,165,233,1))"
                      : "rgba(15,23,42,.7)",
                    color: active ? "#04111d" : "#e2e8f0",
                  }}
                >
                  {label}
                </a>
              );
            })}
          </div>
        </div>

        <div
          style={{
            display: "grid",
            gridTemplateColumns: "minmax(0, 1fr) 320px",
            gap: 20,
          }}
        >
          <div
            style={{
              borderRadius: 24,
              background: "rgba(15,23,42,.78)",
              border: "1px solid rgba(255,255,255,.08)",
              padding: 24,
              boxShadow: "0 22px 60px rgba(0,0,0,.25)",
            }}
          >
            <h2 style={{ margin: 0, fontSize: 24 }}>What unlink does</h2>
            <p style={{ marginTop: 12, lineHeight: 1.8, opacity: 0.9 }}>
              Unlink clears the saved device session, linked organization,
              store/site, device mode, and cached local data for this device.
              After unlinking, the app returns to the link page so you can relink
              it properly.
            </p>

            <div
              style={{
                marginTop: 16,
                padding: 16,
                borderRadius: 16,
                background: "rgba(248,113,113,.08)",
                border: "1px solid rgba(248,113,113,.22)",
                lineHeight: 1.7,
              }}
            >
              Use this when the device was linked into the wrong mode, or when
              testing a new Neo Security install link.
            </div>

            <div style={{ display: "flex", gap: 12, flexWrap: "wrap", marginTop: 20 }}>
              <button
                type="button"
                onClick={handleUnlink}
                style={{
                  cursor: "pointer",
                  color: "#fff",
                  background: "linear-gradient(90deg, #ef4444 0%, #f97316 100%)",
                  padding: "12px 18px",
                  borderRadius: 14,
                  border: 0,
                  fontWeight: 900,
                }}
              >
                Unlink this device
              </button>

              <a
                href="/security/shift"
                style={{
                  textDecoration: "none",
                  padding: "12px 18px",
                  borderRadius: 14,
                  fontWeight: 900,
                  border: "1px solid rgba(255,255,255,.08)",
                  background: "rgba(15,23,42,.7)",
                  color: "#e2e8f0",
                }}
              >
                Back to Shift
              </a>
            </div>
          </div>

          <div style={{ display: "grid", gap: 16 }}>
            <div
              style={{
                borderRadius: 24,
                background: "rgba(15,23,42,.78)",
                border: "1px solid rgba(255,255,255,.08)",
                padding: 24,
                boxShadow: "0 22px 60px rgba(0,0,0,.25)",
              }}
            >
              <div style={{ fontSize: 12, fontWeight: 900, letterSpacing: ".08em", opacity: 0.7 }}>
                CURRENT MODE
              </div>
              <div style={{ marginTop: 10, fontSize: 28, fontWeight: 900 }}>
                Neo Security
              </div>
              <div style={{ marginTop: 8, lineHeight: 1.7, opacity: 0.82 }}>
                This device is currently linked in security / field mode.
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
